<template>
    <div>
		<b-modal ref="modalActDGLot" size="lg" hide-footer @show="init_component">
			<template v-slot:modal-title>
				<template>
					{{ $t("action.creer_dg") }}
				</template>
			</template>

			<div class="col-12">
				<div class="row mb-3">
					<label class="col-sm-4 col-form-label">{{ $t('global.date') }} *</label>
					<div class="col-sm-5">
						<div class="row">
							<e-datepicker class="col" v-model="acte_day" mode="date"></e-datepicker>
							<e-datepicker class="col" v-model="acte_time" mode="time"></e-datepicker>
						</div>
					</div>
				</div>

				<div class="form-group">
					<label for="responses" class="col-form-label">{{ $t("global.result") }} *</label>
					<e-select
						v-model="selected_response"
						id="id"
						label="label"
						:placeholder="labelTitleFormat"
						:deselectLabel="deselectLabel"
						:selectedLabel="selectedLabel"
						:selectLabel="enter_to_select"
						:options="responses_dg"
						:searchable="true"
						:show-labels="false"
						:allow-empty="false"
					>
						<template slot="singleLabel" slot-scope="{ option }">{{ option.label }}</template>
						<template slot="noOptions">{{ $t('global.list_empty') }}</template>
					</e-select>
				</div>

				<div class="form-group">
					<label for="numero_chaleur" class="col-form-label">{{ $t("questions.Numéro de chaleur") }}</label>
					<input class="form-control" type="text" v-model="numero_chaleur" id="numero_chaleur">
				</div>

				<b-button class="mt-3 btn-block rounded-pill" variant="primary" @click="checkForm">{{ $t("action.creer_dg") }} <font-awesome-icon v-if="processing" :icon="['fas', 'spinner']" pulse  class="mr-1"/></b-button>
			</div>
		</b-modal>

		<b-modal ref="modalArticle" size="lg" hide-footer>
			<template v-slot:modal-title>
				<template>
					{{ $t('trigger.entity_type.solde_contract') }}
				</template>
			</template>

			<SoldeContract @submit="closeModal" :couples="couples"/>
		</b-modal>

		<b-modal ref="modalDelierPorteuse" size="lg" hide-footer>
			<template v-slot:modal-title>
				<template>
					{{ $t('acte.trigger.dissociation_contrat_titre') }}
				</template>
			</template>

			<p>{{ $t('acte.trigger.dissociation_contrat_desc') }}</p>

			<div
				v-for="contract in linked_contracts"
				:key="contract.avenant_id"
				class="mb-2"
			>
				<div class="row align-items-center">
					<div class="col">
						<div class="font-weight-bold">{{ contract.contract_num || $t('acte.trigger.contrat_sans_num') }}</div>
						<div class="text-muted">
							{{ contract.porteuse_nom }} — {{ contract.mare_nom }} × {{ contract.stallion_nom }}
							<span v-if="contract.tiers_rs"> — {{ contract.tiers_rs }}</span>
						</div>
					</div>
					<div class="col-auto">
						<b-button variant="primary" @click="delierPorteuse(contract)" :disabled="processing">
							<font-awesome-icon :icon="['fal', 'check']" class="mr-1" />
							{{ $t('acte.trigger.delier_porteuse') }}
						</b-button>
					</div>
				</div>
			</div>

			<div class="text-center mt-3">
				<button @click="closeModalDelierPorteuse" class="btn btn-secondary rounded-pill" :disabled="processing">
					<font-awesome-icon :icon="['fal', 'times']" /> {{ $t('acte.trigger.ignorer') }}
				</button>
			</div>
		</b-modal>
    </div>
</template>

<script type="text/javascript">
import Acte from '@/mixins/Actes.js'
import ActeType from '@/mixins/ActeType.js'
import Common from '@/assets/js/common'
import Gynecologie from '@/mixins/Gynecologie.js'

export default {
	name: "ModalActDGLot",
	mixins: [Acte, ActeType, Gynecologie],
	data () {
		return {
			labelTitleFormat: this.getTrad("acte.choose_result"),
			deselectLabel: this.getTrad("global.press_enter_to_remove"),
			selectedLabel: this.getTrad("global.selected_label"),
			enter_to_select: this.getTrad("global.press_enter_to_select"),
			
			processing: false,
			acte_statut: 1,
			acte_day: new Date(),
			acte_time: new Date(),
			responses_dg: [],
			selected_response: null,
			numero_chaleur: '',
			couples: null,
			acte_type_id: null,
			questions_dg: [],
			porteuse_actes: [],
			linked_contracts: [],
		}
	},
	methods: {
		async init_component() {
			this.responses_dg = []
			this.selected_response = null
			this.numero_chaleur = ''
			this.processing = false

			this.questions_dg = await this.getQuestionsDG()
			this.acte_type_id = this.questions_dg[0].question_fk

			const responses_dg = this.questions_dg.filter(q => q.question_code == 'Résultat')[0]
			responses_dg.question_questiondata.data.forEach((response, i) => {
				let label = null
                if(this.getTrad('reponses.' + [response]).includes('reponses.')) {
                    label = response
                }
                else {
                    label = this.getTrad('reponses.' + [response])
                }
                
				this.responses_dg.push({id: i, label: label})
			})
		},
		openModal(params) {
			this.couples = params
			this.$refs.modalActDGLot.show()
		},
		openModalContract(contracts) {
			let params = []
			let error = false
			contracts.forEach(contract => {
				// Les deux sources (offline Dexie + online API) exposent les objets horse/porteuse résolus
				const porteuse_id = contract.avenant?.porteuse?.horse_id || null
				const mare_id = contract.avenant?.horse?.horse_id || null

				if(!contract.avenant || !contract.config || !contract.config.horse || !contract.seasonmarestallion || !contract.seasonmarestallion.seasonmarestallion_id || (!porteuse_id && !mare_id) || error) {
					error = true
					return
				}

				let couple = {
					seasonmarestallion_id: contract.seasonmarestallion.seasonmarestallion_id,
					horse: {
						horse_nom: contract.config.horse.horse_nom
					}
				}

				if(porteuse_id) {
					couple.porteuse = {
						horse: {
							horse_id: porteuse_id
						}
					}
				}
				else {
					couple.mare = {
						horse: {
							horse_id: mare_id
						}
					}
				}

				params.push(couple)
			})

			if(error) {
				this.failureToast("toast.dg_lot_error")
			}
			else {
				this.couples = params
				this.$refs.modalActDGLot.show()
			}
		},
		closeModal() {
			this.$refs.modalArticle.hide()
			// Après les articles de solde, proposer de délier les porteuses encore associées à un contrat
			if(this.linked_contracts.length > 0) {
				this.$refs.modalDelierPorteuse.show()
			}
			else {
				this.submitModal()
			}
		},
		async checkForm() {
			this.processing = true
			this.porteuse_actes = []

			await Common.asyncForEach(this.couples, async (couple) => {
				if(this.acte_day && this.acte_time) {
					couple.acte_date = new Date(this.acte_day.getFullYear() + '/' + parseInt(this.acte_day.getMonth()+1) + '/' + this.acte_day.getDate() + ' ' + this.acte_time.getHours() + ":" + this.acte_time.getMinutes())
					couple.acte_date.setHours(this.acte_time.getHours())
					couple.acte_date.setMinutes(this.acte_time.getMinutes())
				}
				else {
					couple.acte_date = new Date()
				}

				let reponses = []
				reponses.push({
					reponse_data: [this.selected_response.label],
					reponse_question: this.questions_dg.filter(q => q.question_code == 'Résultat')[0].question_id
				})

				reponses.push({
					reponse_data: [couple.horse.horse_nom],
					reponse_data_hidden: {
						type: "season_mare_stallion",
						id: couple.seasonmarestallion_id
					},
					reponse_question: this.questions_dg.filter(q => q.question_code == 'Étalon')[0].question_id
				})

				// Le numéro de chaleur est facultatif : on ne crée la réponse que s'il est renseigné
				const question_chaleur = this.questions_dg.find(q => q.question_code == 'Numéro de chaleur')
				if(this.numero_chaleur && question_chaleur) {
					reponses.push({
						reponse_data: [this.numero_chaleur],
						reponse_question: question_chaleur.question_id
					})
				}

				let acte_status = 1
				if(this.acte_date > new Date()) {
					acte_status = 0
				}

				let acte_id = null
				if(couple.porteuse) {
					acte_id = await this.addActes([couple.porteuse.horse.horse_id], acte_status, couple.acte_date, '', this.acte_type_id, undefined, null, [], reponses, null, null)
					// Seuls les DG réalisés sur une porteuse peuvent proposer de la délier d'un contrat
					if(acte_status == 1) {
						this.porteuse_actes.push(acte_id[0])
					}
				}
				else {
					acte_id = await this.addActes([couple.mare.horse.horse_id], acte_status, couple.acte_date, '', this.acte_type_id, undefined, null, [], reponses, null, null)
				}
			})
			.then(async () => {
				await this.$sync.force(true)
				await this.loadPorteuseContracts()
				this.processing = false
				this.submitModal()
				this.$refs.modalActDGLot.hide()
				this.checkSaillieRight()
			})
		},

		/* Charge les contrats de transfert encore associés aux porteuses ayant un DG négatif, pour proposer de les délier */
		async loadPorteuseContracts() {
			this.linked_contracts = []

			if(!this.$store.state.userAccess.hasSaillieAccess || !this.constatation_gestation_negative.includes(this.selected_response.label) || this.porteuse_actes.length === 0) {
				return
			}

			// Les actes viennent d'être synchronisés par checkForm : on cible leurs ID serveur
			const actes_ids = this.porteuse_actes.map(acte_id => this.$sync.replaceWithReplicated('horse_actes', acte_id))
			this.linked_contracts = await this.getPorteuseContractsForActes(actes_ids)
		},

		async delierPorteuse(contract) {
			this.processing = true
			await this.assignPorteuseToAvenant(contract.avenant_id, null)
			this.linked_contracts = this.linked_contracts.filter(c => c.avenant_id !== contract.avenant_id)
			this.processing = false

			if(this.linked_contracts.length === 0) {
				this.closeModalDelierPorteuse()
			}
		},

		async closeModalDelierPorteuse() {
			this.$refs.modalDelierPorteuse.hide()
			await this.$sync.force(true)
			this.submitModal()
		},

		async checkSaillieRight() {
			// si la licence n'a pas la monte ou que le DG est positif, je ferme la modale, sinon j'ouvre la modale d'articles
			if(!this.$store.state.userAccess.hasSaillieAccess || this.selected_response.label.includes('DG+')) {
				return false
			}

			this.$refs.modalArticle.show()

		},

		submitModal() {
			this.$emit('submit')
		}
	},

	components: {
		SoldeContract: () => import('@/components/Triggers/SoldeContract'),
	}
}
</script>